/**
 * @prettier
 * @flow
 */
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
import { slice } from 'src/reducers';

const middleware = process.env.NODE_ENV === 'development' ? [immutableStateInvariantMiddleware()] : [];

export const store: { dispatch: Function } = configureStore({
    reducer: combineReducers({
        app: slice.reducer,
    }),
    middleware,
    devTools: false,
    enhancers: [],
});
